<template>
  <div class="credits-result-page">
    <div class="result-card">
      <div class="result-icon cancel">
        !
      </div>

      <h2 class="result-title">
        {{ ui.title }}
      </h2>

      <p class="result-subtitle">
        {{ ui.subtitle }}
      </p>

      <div class="result-actions">
        <button
          type="button"
          class="btn-primary"
          @click="openRecharge"
        >
          {{ ui.choosePack }}
        </button>
        <button
          type="button"
          class="btn-ghost"
          @click="goHome"
        >
          {{ ui.back }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  name: 'CreditsCancel',
  computed: {
    isUiEn() {
      const l = String(this.$i18n?.locale || 'fr').toLowerCase()
      return l === 'en' || l.startsWith('en-')
    },
    ui() {
      if (this.isUiEn) {
        return {
          title: 'Payment canceled',
          subtitle: 'You were not charged. You can try again anytime.',
          choosePack: 'Choose a pack',
          back: 'Back',
        }
      }
      return {
        title: 'Paiement annulé',
        subtitle: 'Aucun débit n’a été effectué. Vous pouvez réessayer quand vous voulez.',
        choosePack: 'Choisir un pack',
        back: 'Retour',
      }
    },
  },
  methods: {
    openRecharge() {
      this.$store.dispatch('credits/openRechargeModal', { message: '' }).catch(() => {})
    },
    goHome() {
      const userData = getUserData()
      this.$router.push(getHomeRouteForLoggedInUser(userData ? userData.role : null)).catch(() => {})
    },
  },
}
</script>

<style scoped>
.credits-result-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(900px 420px at 15% 20%, rgba(56, 182, 255, 0.16), transparent 60%),
    radial-gradient(900px 420px at 90% 10%, rgba(239, 68, 68, 0.18), transparent 55%),
    #0b1220;
}
.result-card {
  background: #fff;
  border-radius: 22px;
  padding: 34px 30px 28px;
  width: 100%;
  max-width: 520px;
  text-align: center;
  box-shadow: 0 28px 72px rgba(0, 0, 0, 0.32);
}
.result-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  font-weight: 900;
  margin: 0 auto 14px;
}
.result-icon.cancel {
  background: rgba(239, 68, 68, 0.14);
  color: #b91c1c;
}
.result-title {
  font-weight: 900;
  color: #0f172a;
  margin-bottom: 6px;
  font-size: 1.4rem;
}
.result-subtitle {
  color: #475569;
  margin-bottom: 18px;
  line-height: 1.5;
}
.result-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}
.btn-primary {
  border: none;
  background: linear-gradient(135deg, #38B6FF, #0096e6);
  color: #fff;
  padding: 12px 20px;
  border-radius: 14px;
  font-weight: 900;
  cursor: pointer;
}
.btn-ghost {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  padding: 12px 18px;
  border-radius: 14px;
  font-weight: 900;
  cursor: pointer;
}
</style>
